import React, { useState, useEffect } from "react";

import Pause from "../images/pause.svg";
import Play from "../images/play.svg";

const useAudio = (url) => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [audio, playing]);

  useEffect(() => {
    audio.addEventListener("ended", () => setPlaying(false));
    return () => {
      audio.removeEventListener("ended", () => setPlaying(false));
    };
  }, [audio]);

  return [playing, toggle];
};

const Player = ({ url }) => {
  const [playing, toggle] = useAudio(url);

  return (
    <div>
      <div onClick={toggle}>
        {playing ? <img src={Pause} alt=''/> : <img src={Play} alt=''/>}
      </div>
    </div>
  );
};

export default Player;
